import theme from "../../theme"

export const MODAL_CONTENT = {
  deleteChatList: {
    name: 'deleteChatList',
    type: 'simple',
    title: null,
    subTitle: null,
    content: '確定清除所有對話紀錄？',
    field: null,
    render: 'default',
    mainColor: theme.palette.primary.main,
    submitTxt: '清除',
    cancelTxt: '取消'
  },
  clearFormSettings: {
    name: 'clearFormSettings',
    type: 'simple',
    title: null,
    subTitle: null,
    content: '確定清空設定？',
    field: null,
    render: 'default',
    mainColor: theme.palette.primary.main,
    submitTxt: '清空',
    cancelTxt: '取消'
  },
}